import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderingDesc = (props) => /* @__PURE__ */ _jsx("svg", {
	direction: "up",
	className: "",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	role: "img",
	focusable: "false",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m4.85 2.623.062.064 2.436 3.008a.5.5 0 0 1-.298.807l-.09.008-1.26-.001c-.12 2.938-.449 7.99-1.19 7.99-.58 0-.972-2.54-1.173-7.621l-.014-.367L2 6.51a.5.5 0 0 1-.435-.748l.052-.074 2.524-3.007a.5.5 0 0 1 .708-.058Zm6.904 9.88a.75.75 0 1 1 0 1.498H9.256a.75.75 0 1 1 0-1.499h2.498Zm.999-2.999a.75.75 0 0 1 0 1.5H9.256a.75.75 0 1 1 0-1.5h3.497Zm.999-2.997a.75.75 0 1 1 0 1.499H9.256a.75.75 0 1 1 0-1.5h4.496Zm.999-2.998a.75.75 0 1 1 0 1.499H9.256a.75.75 0 1 1 0-1.499h5.495Z",
		clipRule: "evenodd"
	})
});
export default SvgOrderingDesc;
